// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RGcm","field":"styles_field__G1L-l","fieldCol":"styles_fieldCol__1zUaE","diffCol":"styles_diffCol__2tjr0","diff":"styles_diff__vw5En"};